import { render, staticRenderFns } from "./complaints-start.vue?vue&type=template&id=11569940&"
import script from "./complaints-start.vue?vue&type=script&lang=js&"
export * from "./complaints-start.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports